/* ============================================================
   VEYLO — cart drawer fix

   This theme keeps an `is-empty` class on the <cart-drawer>
   element, and its CSS hides the drawer header and collapses the
   line-item area while that class is present. Dawn's
   renderContents() only clears `is-empty` from `.drawer__inner`,
   so after an AJAX add the class stays on the wrapper and the
   drawer slides open looking completely empty — even though the
   line items are in the DOM and the total is correct.

   This watches the drawer and clears the class whenever it is
   showing actual line items. It covers every add-to-cart path on
   the storefront, not just Veylo's own.
   ============================================================ */
(function () {
  'use strict';

  function attach() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.veyloCartFix) return;
    drawer.dataset.veyloCartFix = '1';

    var fix = function () {
      var hasItems = !!drawer.querySelector('.cart-item');
      if (!hasItems) return;

      if (drawer.classList.contains('is-empty')) {
        drawer.classList.remove('is-empty');
      }
      var inner = drawer.querySelector('.drawer__inner');
      if (inner && inner.classList.contains('is-empty')) {
        inner.classList.remove('is-empty');
      }
    };

    fix();

    if ('MutationObserver' in window) {
      new MutationObserver(fix).observe(drawer, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  } else {
    attach();
  }

  document.addEventListener('shopify:section:load', attach);
})();
